<template>
    <div class='aTitle'>
      <div class='title'>武昌区重点人群健康管理</div>
    </div>
</template>

<script>
export default {
  name: 'ABigScreemTitle',
  data() {
    return {
      
    };
  },
}
</script>

<style scoped>
.aTitle {
    align-self: center;
    width: 1878px;
    height: 75px;
    background-image: url('~@/assets/images/bigScreem/top_bg.png');
    background-position: center;
}

.title {
  width: 100%;
  height: 100%;
  line-height: 75px;
  text-align: center;
  font-size: 36px;
  color: #0092FF;
}
</style>
